import { apiService } from './api';

export interface StartIdentityVerificationSessionRequest {
  credentialId?: string;
  returnUrl?: string;
}

export interface IdentityVerificationSessionDto {
  sessionId: string;
  userId: string;
  credentialId?: string | null;
  provider: string;
  providerSessionId: string;
  status: string;
  launchUrl?: string | null;
  failureReason?: string | null;
  createdAtUtc: string;
  updatedAtUtc: string;
  completedAtUtc?: string | null;
}

export interface StartIdentityVerificationSessionResponse {
  success: boolean;
  message?: string;
  session?: IdentityVerificationSessionDto;
}

class IdentityVerificationService {
  async startSession(
    request: StartIdentityVerificationSessionRequest
  ): Promise<StartIdentityVerificationSessionResponse> {
    return apiService.post<StartIdentityVerificationSessionResponse>(
      '/api/IdentityVerification/sessions',
      request
    );
  }

  async getSession(sessionId: string): Promise<IdentityVerificationSessionDto> {
    return apiService.get<IdentityVerificationSessionDto>(
      `/api/IdentityVerification/sessions/${encodeURIComponent(sessionId)}`
    );
  }

  async reconcileCallback(
    sessionId: string,
    status?: string
  ): Promise<StartIdentityVerificationSessionResponse> {
    return apiService.post<StartIdentityVerificationSessionResponse>(
      `/api/IdentityVerification/sessions/${encodeURIComponent(sessionId)}/reconcile-callback`,
      { status }
    );
  }
}

const identityVerificationService = new IdentityVerificationService();
export default identityVerificationService;
